import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, FormattedNumber, FormattedMessage } from 'react-intl';
import { Label } from 'react-bootstrap';

import { addNotification } from 'actions/NotificationsActions';
import { deleterDispatchHelper } from 'actions/DeleterActions';
import {
  markInvoiceRefunded,
  markInvoiceDeniedToPay,
  markInvoicePaidAmount,
  setInvoiceSentReminders,
} from 'actions/InvoiceActions';

import Loader from 'components/layout/Loader';
import IntlDate from 'components/layout/IntlDate';
import TableResponsive from 'components/layout/TableResponsive';
// import SimplePrompt from 'components/layout/SimplePrompt';
import InvoicePdfButton from 'components/layout/financial/InvoicePdfButton';
// import InvoiceAuthorizeButton from 'components/layout/financial/InvoiceAuthorizeButton';
import InvoiceActionButton from 'components/layout/financial/InvoiceActionButton';
import InvoiceAmountForm from 'components/layout/financial/InvoiceAmountForm';
import InvoiceRemindersForm from 'components/layout/financial/InvoiceRemindersForm';
import InvoiceCancelButton from 'components/layout/financial/InvoiceCancelButton';

import InvoiceDetails from 'components/modals/InvoiceDetails';

import may from 'js/security';

class InvoicesList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedInvoice: null,
      showInvoiceDetails: false,
      actionIndex: undefined,
    };
  }

  setActionIndex = (index) => {
    this.setState({actionIndex: index});
  }

  showInvoiceDetails = (e, selectedInvoice) => {
    e.stopPropagation();
    e.preventDefault();
    const { showDetailsAction } = this.props;
    if (showDetailsAction) {
      showDetailsAction(selectedInvoice);
    } else {
      this.setState({ showInvoiceDetails: true, selectedInvoice });
    }
  };

  closeInvoiceDetails = () => {
    this.setState({ showInvoiceDetails: false });
  };

  onDelete = invoice => {
    const { deleteInvoice } = this.props;
    deleteInvoice(invoice.id);
  };

  render() {
    const {
      intl: { messages },
      list,
      listName,
      inModal,
      user,
      markInvoiceRefunded,
      markInvoiceDeniedToPay,
      markInvoicePaidAmount,
      setInvoiceSentReminders,
      pendingPayment
    } = this.props;
    const { showInvoiceDetails, selectedInvoice, actionIndex } = this.state;

    const headers = {
      customerInfo: messages.invoice_customer_info,
      billNumber: messages.bill_number,
      status: messages.status,
      issued: messages.salesDoc.issued,
      dueTo: messages.salesDoc.due_date,
      totalDue: messages.salesDoc.total_due,
      payed: messages.salesDoc.payment,
      actions: messages.actions,
    };

    const rows = [];
    for (let i = 0; i < list.length; i++) {
      const invoice = list[i];
      const {
        number,
        number_prefix: numberPrefix,
        sum_gross: sumGross,
        currency,
        cdate,
        payment_info: paymentInfo,
        is_auto_generated: isAutoGenerated,
        is_authorized: isAuthorized,
        authorized_on: authorizedOn,
        authorized_by_name: authorizedByName,
        is_cancelled: isCancelled,
        cancelled_by_name: cancelledByName,
        cancelled_on: cancelledOn,
        original_invoice: originalInvoice,
        is_manually_refunded: isManuallyRefunded,
        is_denied_to_pay: isDeniedToPay,
        sent_reminders: sentReminders,
        target,
        target_data: targetData,
      } = invoice;

      const actions = [<InvoicePdfButton invoice={invoice} key="pdf" />];

      const statuses = [];
      if (isCancelled) {
        statuses.push(
          <span className="text-info" key="cancelled-by-name">
            <FormattedMessage
              id="cancelled_by_name_on_date"
              values={{
                name: cancelledByName,
                date: <IntlDate date={cancelledOn} />,
              }}
            />
          </span>
        );
      } else if (invoice.type === 'cancellation') {
        statuses.push(
          <span className="text-danger" key="is-cancellation">
            {!originalInvoice
              ? messages.salesDoc.cancellation_invoice
              : messages.salesDoc.cancellation_invoice_to +
                ' ' +
                originalInvoice.number_prefix +
                originalInvoice.number}
            {isAutoGenerated ? ` / ${messages.auto_generated}` : null}
          </span>
        );
      } else if (isAutoGenerated) {
        statuses.push(
          <span className="text-info" key="is-autogenerated">
            {messages.auto_generated}
          </span>
        );
      } else if (isAuthorized) {
        statuses.push(
          <span className="text-info" key="authorized_by">
            <FormattedMessage
              id="authorized_by_name_on_date"
              values={{ name: authorizedByName, date: <IntlDate date={authorizedOn} /> }}
            />
          </span>
        );
      }

      if (sentReminders > 0) {
        statuses.push(
          <Label bsStyle="default" key="sent-reminders">
            <i class="far fa-envelope" /> {sentReminders} {messages.sent_reminders}
          </Label>
        );
      }

      if (!isCancelled && may('ROLE_ROOT_EMPLOYEE', user.roles)) {
        actions.push(<InvoiceCancelButton key="deleteInvoice" invoiceId={invoice.id} />);
        /*
          } else {
          status = <Label bsStyle="info">{messages.not_authorized}</Label>;
          if (may('ROLE_ACC_INVOICE', user.roles)) {
            actions.push(<InvoiceAuthorizeButton key="authorizeInvoice" invoiceId={invoice.id} />);
            actions.push(<SimplePrompt key="deleteInvoice" onSuccess={() => this.onDelete(invoice)} />);
          }
        */
      }

      // Mark Invoice as Refunded
      if (isManuallyRefunded) {
        statuses.push(
          <Label key="manuallyrefunded" bsStyle="default">
            <i className="fas fa-undo" /> {messages.refunded}
          </Label>
        );
      } else if (may('ROLE_ROOT_EMPLOYEE', user.roles)) {
        actions.push(
          <InvoiceActionButton
            key="markRefunded"
            bsStyle="default"
            bsSize="xs"
            textConfirm={messages.are_you_sure}
            textButton={messages.invoice_mark_refunded}
            callback={() => markInvoiceRefunded(invoice, true, listName)}
          >
            <i className="fas fa-undo" title={messages.invoice_mark_refunded} />
          </InvoiceActionButton>
        );
      }

      // Mark Invoice as Denied to Pay
      if (isDeniedToPay) {
        statuses.push(
          <React.Fragment key="deniedToPay">
            {' '}
            <Label bsStyle="default">
              <i className="far fa-thumbs-down" /> {messages.denied_to_pay}
            </Label>
          </React.Fragment>
        );
      } else if (may('ROLE_ROOT_EMPLOYEE', user.roles)) {
        actions.push(
          <InvoiceActionButton
            key="markDeniedToPay"
            bsStyle="default"
            bsSize="xs"
            textConfirm={messages.are_you_sure}
            textButton={messages.invoice_mark_denied_to_pay}
            callback={() => markInvoiceDeniedToPay(invoice, true, listName)}
          >
            <i className="far fa-thumbs-down" title={messages.invoice_mark_denied_to_pay} />
          </InvoiceActionButton>
        );
      }

      // Manual entry of amount paid
      if (may('ROLE_ROOT_EMPLOYEE', user.roles)) {
        actions.push(
          <InvoiceAmountForm
            key="partiallyPaid"
            amount={paymentInfo.payed || paymentInfo.amount}
            bsStyle="default"
            bsSize="xs"
            text={{
              title: messages.mark_as_paid,
              confirm: messages.amount_required,
              placeholder: messages.amount,
              button: messages.mark_as_paid,
              // currency: '€',
            }}
            textButton={messages.invoice_mark_denied_to_pay}
            callback={amount => markInvoicePaidAmount(invoice, amount, listName)}
            setActionIndex={this.setActionIndex}
            actionIndex={i}
          >
            <i class="fas fa-euro-sign" title={messages.mark_as_paid} />
          </InvoiceAmountForm>
        );

        actions.push(
          <InvoiceRemindersForm
            key="remindersSent"
            value={sentReminders || 0}
            bsStyle="default"
            bsSize="xs"
            text={{
              title: messages.sent_reminders,
              confirm: messages.number_of_sent_reminders,
              placeholder: messages.attributeName.number,
              button: messages.set_number,
            }}
            textButton={messages.invoice_mark_denied_to_pay}
            callback={value => setInvoiceSentReminders(invoice, value, listName)}
          >
            <i class="far fa-envelope" title={messages.number_of_sent_reminders} />
          </InvoiceRemindersForm>
        );
      }

      const dueDate = paymentInfo.bill_payment && paymentInfo.bill_payment.due_date ? <IntlDate date={paymentInfo.bill_payment?.due_date} />  : '';
      const paymentAmount = Number(paymentInfo.amount || invoice.sum_gross).toFixed(2);
      const payedAmount = Number(paymentInfo.payed || 0).toFixed(2);
      const balance = paymentAmount - payedAmount; // round to cents
      const payed = isCancelled ? (
        <Label bsStyle="danger">{messages.salesDoc.cancelled}</Label>
      ) : balance === 0 ? (
        <Label bsStyle="success">{messages.salesDoc.payed}</Label>
      ) : balance > 0 ? (
        <Label bsStyle="danger">
          {messages.salesDoc.to_pay}
          <FormattedNumber value={Math.abs(balance)} style="currency" currency={currency} />
        </Label>
      ) : (
        <Label bsStyle="info">
          {messages.salesDoc.to_refunded}
          <FormattedNumber value={Math.abs(balance)} style="currency" currency={currency} />
        </Label>
      );

      // divide status Labels with whitespace
      const status = [...statuses];
      for (let i = status.length - 1; i > 0; i--) {
        status.splice(i, 0, <React.Fragment key={'space-' + i}> </React.Fragment>);
      }

      let debtorNumber = target?.alternative_effective_debtor_number ?? target?.effective_debtor_number;
      debtorNumber = debtorNumber ? `#${debtorNumber}` : '';
      const companyName = target?.profile?.company ? ` - ${target.profile.company}` : '';
      const targetName = targetData ? ` / ${targetData.first_name} ${targetData.last_name}` : '';

      const rowData = {
        customerInfo: `${debtorNumber}${companyName}${targetName}`,
        billNumber: '#' + (numberPrefix || '') + (number || '?'),
        status: <>{status}</>,
        issued: <IntlDate date={cdate} />,
        dueTo: dueDate,
        totalDue: <FormattedNumber value={sumGross} style="currency" currency={currency} />,
        payed: pendingPayment && actionIndex === i ? <Loader small /> : payed,
        actions,
        onClick: e => this.showInvoiceDetails(e, invoice),
      };

      rows.push(rowData);
    }

    return list.pending ? (
      <Loader />
    ) : (
      <>
        {!inModal || (inModal && !showInvoiceDetails) ? <TableResponsive headers={headers} rows={rows} hover /> : null}

        <InvoiceDetails
          alreadyInModal={inModal}
          show={showInvoiceDetails}
          close={this.closeInvoiceDetails}
          invoice={selectedInvoice}
        />
      </>
    );
  }
}

InvoicesList.defaultProps = {
  inModal: false,
  showDetailsAction: null,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    invoiceDeleter: state.deleter.invoice,
    pendingPayment: state.list.invoices.pendingPayment
  };
};

const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    deleteInvoice: invoiceId => {
      deleterDispatchHelper('invoice', `/api/invoices/${invoiceId}.json`, dispatch);
    },
    markInvoiceRefunded: (invoice, value, listName) => dispatch(markInvoiceRefunded(invoice, value, listName)),
    markInvoiceDeniedToPay: (invoice, value, listName) => dispatch(markInvoiceDeniedToPay(invoice, value, listName)),
    markInvoicePaidAmount: (invoice, amount, listName) => dispatch(markInvoicePaidAmount(invoice, amount, listName)),
    setInvoiceSentReminders: (invoice, value, listName) => dispatch(setInvoiceSentReminders(invoice, value, listName)),
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(InvoicesList)
  )
);
